export const config = {
  apiUrl: "//napi.egzotech.com",
  egzoAPIUrl: "/api/",
  passwordPolicy:
  {
    length : "6"
  }
};



// WEBPACK FOOTER //
// ../configuration.ts